import { EnvironmentSpecific } from "./environment.interface";

const website = "https://energyplatform.nl";
export const energywalks: EnvironmentSpecific = {
  identifier: "app.energywalks",
  calendarColor: "orange",
  hasAuthentication: false,
  iosAppstoreId: "1496618074",
  type: "business",
  environmentName: "energywalks",
  website,
  contact: `${website}/contact/`,
  name: "EnergyWalks",
  youtube: "https://www.youtube.com/channel/UCW3nM-TdY0w4xpXH9rZz71A/",
  instagram: "https://www.instagram.com/energyplatform/",
  facebook: "https://www.facebook.com/EnergyPlatform-667736646619784/",
  terms: `${website}/wp-content/themes/energyplatform/assets/pdf/Gebruiksvoorwaarden%20Employee%20Wellbeing%20Company%20voor%20EnergyPlatform%20App.pdf`,
  privacy: `${website}/wp-content/themes/energyplatform/assets/pdf/Privacy%20en%20cookie%20voorwaarden%20Employee%20Wellbeing%20Company%20BV.pdf`,
  oneSignalAppId: "cf54150e-7a0c-40ad-acfc-9226b14c7d18",
};
